import { styled } from "../../stitches.config";

export const Image = styled("img", {
  variants: {
    fullWidth: {
      true: {
        width: "100%",
      },
    },
  },
});
